import { Component, OnDestroy, OnInit } from '@angular/core';
import { CookieConsentService } from './services/cookie-consent.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(private cookieConsentService: CookieConsentService) {}

  ngOnInit(): void {
    this.cookieConsentService.init();
  }

  ngOnDestroy(): void {
    this.cookieConsentService.destroy();
  }
}
